export const RegionsConfig: { [key: string]: { en: string; cn: string; }; } = {
  Worldwide: {
    en: 'Worldwide',
    cn: '全球',
  },
  Europe: {
    en: 'Europe',
    cn: '欧洲',
  },
  'Eastern Europe': {
    en: 'Eastern Europe',
    cn: '东欧',
  },
  'Western Europe': {
    en: 'Eastern Europe',
    cn: '东欧',
  },
  'North America': {
    en: 'North America',
    cn: '北美洲',
  },
  Japan: {
    en: 'Japan',
    cn: '日本',
  },
  Australia: {
    en: 'Australia',
    cn: '澳大利亚',
  },
  'South America': {
    en: 'South America',
    cn: '南美洲',
  },
  Asia: {
    en: 'Asia',
    cn: '亚洲',
  },
  'Southeast Asia': {
    en: 'Southeast Asia',
    cn: '东南亚',
  },
  Oceania: {
    en: 'Oceania',
    cn: '大洋洲',
  },
  China: {
    en: 'China',
    cn: '中国',
  },
  Korea: {
    en: 'Korea',
    cn: '韩国',
  },
  Taiwan: {
    en: 'Taiwan',
    cn: '台湾',
  },
  'Hong Kong': {
    en: 'Hong Kong',
    cn: '香港',
  },
  India: {
    en: 'India',
    cn: '印度',
  },
  'Middle East': {
    en: 'Middle East',
    cn: '中东',
  },
  Africa: {
    en: 'Africa',
    cn: '非洲',
  },
  Russia: {
    en: 'Russia',
    cn: '俄罗斯',
  },
};
